import { render, staticRenderFns } from "./saleOrderSetting.vue?vue&type=template&id=4ecad75e&scoped=true"
import script from "./saleOrderSetting.vue?vue&type=script&lang=js"
export * from "./saleOrderSetting.vue?vue&type=script&lang=js"
import style0 from "./saleOrderSetting.vue?vue&type=style&index=0&id=4ecad75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecad75e",
  null
  
)

export default component.exports